// @flow

import $ from 'jquery'

export default class JobVacancies {
  static init () {
    if (document.querySelector('.vol_job_vacancies')) {
      $('.vol_job_vacancies tr:not(:first-child) td').on('click', function (event) {
        const link = $(this).parent().find('a.fake-download-link')

        if (link && link.get(0)) {
          link.get(0).click()
        }
      })
    }
  }
}
